import { useState } from "react";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import CurrencyProvider from "pages/useContext";

import NotificationModal from "components/modal/notification-modal";
import CheckoutForm from "components/checkouForm";

import HelpDesk from "components/help-desk";
import WhatsNewModal from "components/whatsNewModal";
import { LanguageProvider, useTranslation } from "i18n";
import { isStandaloneRoute } from "utils/standalone-routes";

import { AppTheme } from "./theme";

import "assets/css/global.css";

import { AppRouter } from "router";

//----------------------------------------------------------------

function AppContent() {
  const { t } = useTranslation();
  const currency = JSON.parse(
    localStorage.getItem("satyam-currency")
  )?.currency;

  const stripe_key =
    currency === "EUR"
      ? process.env.REACT_APP_STRIPE_EUR
      : process.env.REACT_APP_STRIPE_USD;

  const stripePromise = loadStripe(stripe_key);
  const [clientSecret, setClientSecret] = useState("");
  const [openCheckout, setOpenCheckout] = useState("");

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
  };

  const goToFeedback = () => {
    window.location.href = "/feedback";
  };

  const standalone = isStandaloneRoute(location.pathname);

  return (
    <ThemeProvider theme={AppTheme}>
      <CssBaseline />

      {/* <NotificationModal /> */}
      <CurrencyProvider>
        <div className={standalone ? "main-view main-view--standalone" : "main-view"}>
          {!standalone && (
            <div
              className="feedback-stick"
              role="link"
              tabIndex={0}
              onClick={goToFeedback}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") goToFeedback();
              }}
            >
              <TextsmsIcon sx={{ width: "14px" }} />
              <p>{t("common.feedback")}</p>
            </div>
          )}
          <AppRouter
            setClientSecret={setClientSecret}
            setOpenCheckout={setOpenCheckout}
          />

          {!standalone && (
            <>
              {/***** HelpDesk Modal *****/}
              <HelpDesk />
              <WhatsNewModal />
            </>
          )}
        </div>
      </CurrencyProvider>

      {/***** Stripe Payment Modal *****/}
      {clientSecret && openCheckout && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm
            clientSecret={clientSecret}
            setClientSecret={setClientSecret}
          />
        </Elements>
      )}
    </ThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
